import { useEffect } from "react"

export function useScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) return

    const scrollY = window.scrollY
    const original = document.body.style.cssText

    document.body.style.cssText = `
      overflow: hidden;
      position: fixed;
      top: -${scrollY}px;
      left: 0;
      right: 0;
      width: 100%;
    `

    return () => {
      document.body.style.cssText = original
      window.scrollTo(0, scrollY)
    }
  }, [locked])
}
